document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initContadores();
  initCarruselResenas();
  initFaq();
  initComparadorTilt();
});

function initReveal() {
  var els = document.querySelectorAll('.amb-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('amb-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('amb-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { observer.observe(el); });
}

function initContadores() {
  var els = document.querySelectorAll('.amb-contador');
  if (!els.length) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      observer.unobserve(el);
      var fin = parseFloat(el.getAttribute('data-fin') || '0');
      var decimales = el.getAttribute('data-decimales') === '1';
      var duracion = 1400;
      var inicio = null;
      function paso(ts) {
        if (!inicio) inicio = ts;
        var progreso = Math.min((ts - inicio) / duracion, 1);
        var valor = fin * (1 - Math.pow(1 - progreso, 3));
        el.textContent = decimales ? valor.toFixed(1) : Math.round(valor);
        if (progreso < 1) requestAnimationFrame(paso);
        else el.textContent = decimales ? fin.toFixed(1) : fin;
      }
      requestAnimationFrame(paso);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { observer.observe(el); });
}

function initCarruselResenas() {
  var wrap = document.querySelector('[data-amb-resenas]');
  if (!wrap) return;
  var track = wrap.querySelector('.amb-resenas-track');
  var prev = wrap.querySelector('[data-amb-prev]');
  var next = wrap.querySelector('[data-amb-next]');
  if (!track) return;
  var card = track.querySelector('.amb-resena');
  if (!card) return;

  function step() {
    var gap = parseFloat(getComputedStyle(track).gap || '0');
    return card.getBoundingClientRect().width + gap;
  }
  if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
}

function initFaq() {
  var items = document.querySelectorAll('.amb-faq-item');
  items.forEach(function (item) {
    var btn = item.querySelector('.amb-faq-pregunta');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var estabaAbierto = item.classList.contains('amb-faq-abierto');
      item.parentElement.querySelectorAll('.amb-faq-item').forEach(function (i) {
        i.classList.remove('amb-faq-abierto');
      });
      if (!estabaAbierto) item.classList.add('amb-faq-abierto');
    });
  });
}

function initComparadorTilt() {
  var tarjetas = document.querySelectorAll('[data-amb-tilt]');
  if (!tarjetas.length) return;
  if (window.matchMedia('(hover: none)').matches) return;
  tarjetas.forEach(function (t) {
    t.addEventListener('mousemove', function (e) {
      var r = t.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5;
      var y = (e.clientY - r.top) / r.height - 0.5;
      t.style.transform = 'perspective(700px) rotateY(' + (x * 6) + 'deg) rotateX(' + (y * -6) + 'deg) translateY(-4px)';
    });
    t.addEventListener('mouseleave', function () {
      t.style.transform = '';
    });
  });
}
